module.exports = __webpack_public_path__ + "static/media/Piercing-eyebrow-symmetry.7862205b.png";